var exports = {
  "EW": "taskLabel__1Wh-E5",
  "lx": "sessionNavItem__FYhhXl",
  "j2": "neutralDot__i5FM_t",
  "nH": "loadingStatus__m2WjIy",
  "lF": "sessionTrailingVisual__7MaLK_",
  "Ly": "readOnlyTrailingVisual__SF7xan",
  "H_": "hovercard__KK-22_",
};

module.exports = exports;
